import { useContext } from 'react'
import { NotificationsContext } from 'contexts'

export const usePageNotifications = () => {
  const { state, dispatch } = useContext(NotificationsContext)

  return {
    ...state,
    dispatch,
  }
}
